import { handleNav, footerLinks } from '../../Utils';
import OneTrustLink from './OneTrustLink';

const linksGroup1 = footerLinks.slice(0, 4);
const linksGroup2 = footerLinks.slice(4);

export default function FooterComponent() {

    return (
        <div className="row text-bg-dark py-4" id="footerNMPlus">
            <div className="col text-center my-4">
                <p className="fs-6">
                    <small>
                        {linksGroup1.map((link, i) => (
                            <span key={link.label}>
                                <a href={link.url} onClick={(e) => handleNav(e)}>{link.label}</a>
                                {i < linksGroup1.length - 1 && <span> &nbsp;|&nbsp; </span>}
                            </span>
                        ))}
                        <br />
                        {linksGroup2.map((link, i) => (
                            <span key={link.label}>
                                <a href={link.url} onClick={(e) => handleNav(e)}>{link.label}</a>
                                {i < linksGroup2.length - 1 && <span> &nbsp;|&nbsp; </span>}
                            </span>
                        ))}
                        <br />
                        <OneTrustLink />
                        <div className="text-center my-5 mb-2"><p className="fw-light rights-reserved">&copy; {new Date().getFullYear()}  Newsmax Media, LLC. All rights reserved. Newsmax+ & Newsmax2 are property of Newsmax Media.</p></div>
                    </small>
                </p>
            </div>
        </div>    
    )
}